import React from 'react';
import styles from '../styles/related-entities-widget.module.scss';
import classNames from "classnames";
import {ACTION_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import type {EntityLogoProps} from "../../../core/components/logos/entity-logo";
import {EntityLogo} from "../../../core/components/logos/entity-logo";
import {Link} from "../../../core/components/link/link";
import {Ellipsis} from "../../../core/components/misc/ellipsis/ellipsis";
import {KeyboardArrowLeft} from "../../../core/icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../../core/icons/keyboard-arrow/keyboard-arrow-right";

export const RelatedEntitiesWidgetContentItem = ({controller, item}) => {
  const {state: {currentLinkModel}, device: {isRtl, isSmallView}} = controller;

  const linkProps = {
    className: classNames(styles.item_container),
    model: item.linkModel,
    onClick: () => controller.action(ACTION_TYPES.entityClick, {
      entityId: item.id,
      entityName: item.nameForURL,
      entityType: APP.ANALYTICS.USER_SELECTIONS.TYPES.AthleteViewModel,
      source: APP.ANALYTICS.SOURCES.relatedAthletes,
      sportTypeId: item.domainModel.sport.id,
      currentLinkModel
    })
  };

  const logoProps: EntityLogoProps = {
    entity: item,
    height: 40,
    width: 40,
    className: classNames(styles.entity_logo)
  };

  const ellipsisProps ={
    numOfMaxLines: 2,
    text: item.name,
    className: classNames(styles.entity_name)
  };

  return (
    <Link {...linkProps}>
      <div className={classNames(styles.logo_container)}>
        <EntityLogo {...logoProps}/>
      </div>
      <Ellipsis {...ellipsisProps}/>
      <span className={classNames(styles.entity_sub_text)}>{item.relatedEntitySubText}</span>
      {
        isSmallView ? null :
        isRtl ? <KeyboardArrowLeft className={classNames(styles.arrow)}/> : <KeyboardArrowRight className={classNames(styles.arrow)}/>
      }
    </Link>
  )
};